import { categories } from "@/mocks/home";

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
        <div>
          <span className="text-primary-600 text-xs font-medium tracking-[0.24em] uppercase">
            Resource Navigation
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            资源导航 · 快速定位
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-2xl">
            把零散的写真、视频与福利内容按板块整理，从入口直达你想要的资源。
          </p>
        </div>
        <a
          href="#updates"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          查看全站索引
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href="#gallery"
            className="group bg-background-50 border border-background-200/80 hover:border-primary-300 rounded-lg p-5 flex items-start gap-4 transition-colors cursor-pointer"
          >
            <span className="w-12 h-12 shrink-0 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <span className="flex flex-col min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading font-bold text-foreground-950 text-base">
                  {cat.name}
                </span>
                <span className="text-[11px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-600">
                  {cat.count}
                </span>
              </span>
              <span className="text-sm text-foreground-600 mt-1.5">{cat.desc}</span>
            </span>
            <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 ml-auto shrink-0 transition-colors" />
          </a>
        ))}
      </div>
    </section>
  );
}